import React from "react";
import { NavLink } from "react-router-dom";

function PortalLeftNav() {
  return (
    <aside className="sidebar text-center">
      {/* Portal Logo */}
      <img 
        src={`${process.env.PUBLIC_URL}/logo.svg`} 
        alt="Logo" 
        className="admin-logo mb-3 mt-2" 
        style={{ maxWidth: "150px" }} 
      />

      <nav className="menu">
        <NavLink to="/portal/permits" className={({ isActive }) => (isActive ? "active" : "")}>
          <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="" className="px-2" style={{ maxWidth: "35px" }} />
          Simplepermit ™
        </NavLink>
        <hr className="my-2" />
        <NavLink to="/portal/check" className={({ isActive }) => (isActive ? "active" : "")}>
          <img src={`${process.env.PUBLIC_URL}/simplechecklogo.png`} alt="" className="px-2" style={{ maxWidth: "35px" }} />
          Simplecheck ™
        </NavLink>
        <hr className="my-2" />
        <NavLink to="/portal/spect" className={({ isActive }) => (isActive ? "active" : "")}>
          <img src={`${process.env.PUBLIC_URL}/simplespect.png`} alt="" className="px-2" style={{ maxWidth: "35px" }} />
          Simplespect ™
        </NavLink>
      </nav>
    </aside>
  );
}

export default PortalLeftNav;
